module.exports = __webpack_public_path__ + "img/paragon--alt.30925eff.svg";